import { Ban } from "lucide-react";

import { miniaturaDe } from "./miniatura";
import { medidaDoItem, qtdDoItem } from "../../lib/unidadeVenda";

const hora = (iso) => {
  const d = iso ? new Date(iso) : null;
  return d && !Number.isNaN(d.getTime()) ? d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }) : "";
};

/** Produtos cancelados da mesa, riscados, na comanda do garçom (dono,
 *  25/09/2026) — antes sumiam da lista e ninguém sabia o que tinha saído.
 *  `produtos` (cadastro): peso sai "1,250 kg" (30/09/2026). */
export default function ItensCancelados({ itens, produtos }) {
  const lista = (itens || []).filter((i) => i.deleted);
  if (!lista.length) return null;
  return (
    <div className="border-t pt-4" data-e2e="mesa-cancelados">
      <p className="text-xs font-semibold text-red-500 uppercase mb-2 flex items-center gap-1">
        <Ban className="w-3.5 h-3.5" /> Cancelados ({lista.length})
      </p>
      <div className="space-y-1.5">
        {lista.map((item, i) => (
          <div key={item.cartItemId || `${item.id}-${i}`} className="flex items-center gap-2 p-2 rounded-lg bg-red-500/5 border border-red-500/20 opacity-80">
            <div className="w-8 h-8 bg-muted rounded-md flex-shrink-0 overflow-hidden grayscale">
              {item.photo_url ? <img src={miniaturaDe(item.photo_url, 128)} alt="" className="w-full h-full object-cover" loading="lazy" /> : null}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium truncate line-through decoration-red-500/70">{qtdDoItem(item.quantity || 1, medidaDoItem(item, produtos))} {item.name || item.nome}</p>
              <p className="text-[11px] font-semibold text-red-500">
                cancelado{hora(item.deleted_at) ? ` às ${hora(item.deleted_at)}` : ""}
                {item._lancado_por?.nome ? <span className="text-muted-foreground font-normal"> · lançado por {item._lancado_por.nome}</span> : null}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
